$(function() {
  // 商品購入ページ
  // if ($('#sysItemDetail').length) {
  //   $('.sysForm #sysSubmit').append('<svg class="c-ec-icon__svg"><use xlink:href="#ico_cart"></use></svg>');
  // }

  // ページロード時にカート内の商品数を取得して表示する処理
  function itemCount(target) {
    let numberBox = '';
    let itemNumber = 0;
    let items = '';

    function count() {
      numberBox = $('.sysCartInfoItemCount dd span');
      itemNumber = numberBox.text();
      items = Number(itemNumber);
      console.log(items);

      if (items != 0 && items != undefined) {
        target.text(items);
      }
    }

    function init() {
      // 商品詳細ページからカートに商品を追加した場合に、商品数表示を更新
      $('#sysItemDetail .sysCartButton').on({
        'click': function() {
          setTimeout(count, 3000);
        }
      });
      // 商品カテゴリーページからカートに商品を追加した場合に、商品数表示を更新
      $('#sysItemCategory .sysCartButton').on({
        'click': function() {
          setTimeout(count, 3000);
        }
      });
      // $(document).on('change', '#sysBasket select[name="num"]', function(){
      //   console.log('test');
      //   setTimeout(count, 3000);
      // });
      count();
    }
    init();
  }
  // itemCount(ポップアップアイコン)をターゲットとしてitemCount関数を呼び出し
  itemCount($('.js-item-count'));

  // ログインしている時は会員登録アイコンを表示にする
  function signinInfo() {
    const signinInfo = $('.sysFuncMemberLogin');
    if (signinInfo.find('a').text() !== 'マイページログアウト') {
      $('.js-signup').css('display', 'inline-block');
    } else {
      $('.js-signup').css('display', 'none');
    }
  }
  signinInfo();

  $('#sysItemDetail #sysCartInForm').attr('name', 'itemDetail');
  const $cartBtn = $('#sysItemDetail #sysSubmit');
  const $btn = $('#sysItemDetail #sysWishlist .sysButton');
  const $wish = $('.sysWishListButtonFormAjax');
  const $cart = $('#sysItemDetail #sysSubmit .sysCartButton');
  const $newBtn = $('<button value="true" class="btn-favorite"><svg class="btn-favorite__svg" width="27" height="27" ><use xlink:href="#ico_favorite" /></svg><span class="btn-favorite__txt">お気に入り</span></button>')
  $btn.css('display', 'none');
  $wish.append($newBtn);
  $(document).on('click', '.btn-favorite', function(e) {
    e.preventDefault();
    $('.sysWishListButton').trigger('click');
  });
  $cart.remove();
  $cartBtn.append('<button type="submit" value="カートに入れる" class="btn-cart"><svg class="btn-cart__svg" width="27" height="27"><use xlink:href="#ico_cart_btn" /></svg><span class="btn-cart__txt">カートに入れる</span></button>');
  if ($('.sysPr').find('span').hasClass('soldout')) {
    changeBtnDisabled();
  }

  // 商品購入ページ
  if ($('#sysItemDetail').length >= 1) {
    if ($('#variation').length >= 1) {
      console.log('test');
      $($('.sysImageList li').get().reverse()).each(function () {
        var PassName = $(this).children('img').attr('src');
        var FileName = basePassName(PassName);
        var name = baseFileName(FileName);
        var val = $('#variation').val();
        console.log('val:', val);
        console.log('name:', name);
        if (val !== name) {
          $(this).css('display', 'none');
        } else {
          $(this).css('display', 'inline-block');
          $(this).children('img').trigger('click');
        }
      });
    }

    $(document).on('change', '#variation', function () {
      var val = $(this).val();
      $($('.sysImageList li').get().reverse()).each(function () {
        var PassName = $(this).children('img').attr('src');
        var FileName = basePassName(PassName);
        var name = baseFileName(FileName);
        if (val !== name) {
          $(this).css('display', 'none');
        } else {
          $(this).css('display', 'inline-block');
          $(this).children('img').trigger('click');
        }
      });
      judgeBtnStatus(val);
    });
  }

  // 会員登録画面でメルマガのチェックを外す
  if ($('#sysMemberRegisterIndex').length >= 1) {
    $('#sysMemberRegisterIndex input[name="accept_mailmagazine"]').removeAttr('checked').attr('value', '0');
  }

  // カートページ
  if ($('#sysBasket').length >= 1) {
    // let $html = $('.sysSubTotalArea');
    // $html.each(function() {
    //   let html = $(this).html();
    //   console.log('html:', html);
    //   const str = html.replace(/[・送料は後ほど連絡]/g, '');
    //   console.log('str:', str);
    //   $(this).html(str);
    // });
    $('.sysSubTotalArea').each(function () {
      $(this).find('.sysTaxText').text('税込');
      const html = $(this).html();
      console.log('html:', html);
      const text = html.replace(/通常送料/g, '');
      console.log('text:', text);
      $(this).html(text);
    });
  }

  getdata();

  // 注文内容確認
  if ($('#sysConfirm').length >= 1) {
    $('.sysSubTotalArea').each(function() {
      $('#sysConfirm .sysSubTotalArea .sysTaxText').text('税込');
      const text = $('#sysConfirm .sysProduct .sysSubTotalArea').html().replace('通常送料', '');
      $('#sysConfirm .sysProduct .sysSubTotalArea').html(text);
    });

    $('.sysDetail .sysCartTitle').text('ご注文内容');

    const note = '<p class="confirm-note">※離島、一部地域の方で表示されている送料が変更になる場合がございます。対象の方には、後程メールでご連絡させていただきます。</p>';
    $('#sysConfirm .sysTotal .sysBox').append(note);
  }

  // 会員情報編集確認ページの装飾を外す
  if ($('#sysMypageEditConfirm').length >= 1) {
    $('#sysMypageEditConfirm .sysFormLabel').each(function () {
      var txt = $(this).text();
      $(this).text(txt.replace('■', ''));
    });
  }
});

function getdata() {
  if (window.location.search) {
    /* URLの「?」以降のパラメータを変数nに代入 */
    console.log('xxx:');
    let n = window.location.search.substring(1, window.location.search.length);
    n = n.replace(/\//g, '');
    const index = n.indexOf('5D=');
    const len = n.length;
    const str = n.slice(index + 3, index + (len - index));
    $('#sysItemDetail #sysVariation option').each(function () {
      if ($(this).attr('value') === n || $(this).attr('value') === str) {
        $(this).attr('selected', '1');
      }
    });
    judgeBtnStatus(n);
  }
}

function baseFileName(str) {
  var base = new String(str).substring(str.lastIndexOf('/') + 1);
  if (base.lastIndexOf(".") != -1)
    base = base.substring(0, base.lastIndexOf("."));
  return base;
}

// パスからファイル名を抽出する関数
function basePassName(yourstring) {
  var fileNameIndex = yourstring.lastIndexOf("/") + 1;
  var filename = yourstring.substr(fileNameIndex);
  var fileNameIndex2 = filename.lastIndexOf("-") + 1;
  filename = filename.substr(fileNameIndex2);
  var sourceStr = filename;

  var targetStr = "_01";
  var targetStr2 = "_02";
  var targetStr3 = "_03";
  var targetStr4 = "_04";

  var regExp = new RegExp(targetStr, "g");
  var regExp2 = new RegExp(targetStr2, "g");
  var regExp3 = new RegExp(targetStr3, "g");
  var regExp4 = new RegExp(targetStr4, "g");

  var a = sourceStr.replace(regExp, "");
  a = a.replace(regExp2, "");
  a = a.replace(regExp3, "");
  a = a.replace(regExp4, "");

  return a;
}

function judgeBtnStatus(val) {
  val = $.trim(val);
  let text = $('option[value="' + val + '"]').text();
  text = $.trim(text);
  const str = text.includes('×');
  if (str) {
    changeBtnDisabled();
  } else {
    changeBtnAbled();
  }
}

function changeBtnDisabled() {
  $('.btn-cart').attr('disabled', 1);
  $('#sysItemDetail #sysCartInForm #sysNumber').css('visibility', 'hidden');
  $('.btn-cart').addClass('-is-soldout');
}

function changeBtnAbled() {
  $('.btn-cart').removeAttr('disabled');
  $('#sysItemDetail #sysCartInForm #sysNumber').css('visibility', 'visible');
  $('.btn-cart').removeClass('-is-soldout');
}

